module.exports = __webpack_public_path__ + "img/矩形 592 拷贝@2x.3931b980.png";